import { render, staticRenderFns } from "./form.vue?vue&type=template&id=499dba59&scoped=true&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"
import style0 from "./form.vue?vue&type=style&index=0&id=499dba59&lang=css&"
import style1 from "./form.vue?vue&type=style&index=1&id=499dba59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499dba59",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('499dba59')) {
      api.createRecord('499dba59', component.options)
    } else {
      api.reload('499dba59', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=499dba59&scoped=true&", function () {
      api.rerender('499dba59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hotel/form.vue"
export default component.exports